import type { ObservableMap } from '@stencil/store';
import { createStore } from '@stencil/store';

import type { TableStateInterface, TableColumnInterface } from '../../../../services/interfaces';

const tableStates = new Map<string, ObservableMap<TableStateInterface>>();

/**
 * Get the current state of a giving table element
 * @param  {string} tableId Table unique identifier
 * @return {TableStateInterface} Table state
 */
export const getTableState = (tableId: string): TableStateInterface => tableStates.get(tableId)?.state;

/**
 * Set a new state for a giving table element
 * @param  {string} tableId Table unique identifier
 * @param  {TableStateInterface} newState
 * @returns void
 */
export const setTableState = (tableId: string, newState: TableStateInterface): void => {
  tableStates.set(tableId, createStore(newState));
};

/**
 * Remove the state for a giving table element
 * @param  {string} tableId Table unique identifier
 * @returns void
 */
export const removeTableState = (tableId: string): void => {
  tableStates.get(tableId)?.reset();
  tableStates.delete(tableId);
};

/**
 * Set the state column attributes for a giving table
 * @param  {TableStateInterface} tableState
 * @param  {TableColumnInterface} opts
 * @returns void
 */
export const setTableColumnOptions = (tableState: TableStateInterface, opts: TableColumnInterface): void => {
  if (!tableState) return;

  const column = tableState.cols?.find((col) => col.columnKey === opts.columnKey);
  if (!column) {
    tableState.cols = [...(tableState.cols ?? []), opts];
  } else {
    column.width = opts.width;
    column.usePercentageWidth = opts.usePercentageWidth;
    column.isHidden = opts.isHidden;
  }
};
